import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getPagesApi } from '../../services/api';

export const pagesFun = createAsyncThunk('/pages', async () => {
  try {
    const response = await getPagesApi();
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
});

const pagesSlice = createSlice({
  name: 'pages',
  initialState: {
    submitting: false,
    error: null,
    success: false,
    language:'',
    pages:[],
  },
  reducers: {
  },
  extraReducers: builder => {
    builder
      .addCase(pagesFun.pending, state => {
        state.submitting = true;
        state.error = null;
        state.success = false;
      })
      .addCase(pagesFun.fulfilled, (state,action) => {
        state.submitting = false;
        state.success=true;
        state.pages=action.payload;
      })
      .addCase(pagesFun.rejected, (state, action) => {
        state.submitting = false;
        state.error = action.payload.error;
        state.success = false;
      })
  },
});
export default pagesSlice.reducer;

